module.exports = __webpack_public_path__ + "static/media/Selflove.39fd01f4.jpg";